import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb0018',
    ecrans: ['00-2']
});
